<template>
    <div class="">
        <b-overlay :show="showoverlay_list" rounded="sm">

            <template v-if="is_trustee == 1">

                <div class="clearfix company-form-container company-form-container-warapper">
                    <div class="company-form-container-title-wrapper">
                        <div class="col-sm-12 px-3 company-form-box-title">
                            Provident Fund Advance Applications
                        </div>
                    </div>
                    <div class="col-md-12 company-form-container-content-wrapper">
                        <div v-if="loans.length>0">
                            <common-list list_type="pf_loan_application" :action_btn_text="action_btn_text" :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" is_pf="1" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                        </div>
                        <div v-else>
                            <div v-if="show_loader" class="list-no-data">
                                <span class="d-block text-center">Looking for relevant data..</span>
                                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                            </div>
                            <div v-else class="list-no-data">
                                Looks like there is no PF advance application to show.
                            </div>
                        </div>
                    </div>
                </div>

            </template>
            <template v-else>
                <div v-if="loans.length>0">
                    <common-list list_type="pf_loan_application" :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" is_pf="1" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                </div>
                <div v-else class="mb-3 pb-3"> <!-- Mustafijur: 23-05-2026: added mb-3 pb-3 -->
                    <div v-if="show_loader" class="list-no-data">
                        <span class="d-block text-center">Looking for relevant data..</span>
                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    </div>
                    <div v-else class="list-no-data">
                        Looks like there is no PF advance application to show.
                    </div>
                </div>
            </template>




        </b-overlay>


        <b-modal id="delete-modal" title="Are you sure you want to delete this Advance ?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="delete-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to continue:
            <br />
            <input type="text" style="display:none;" autocomplete="username"> <!-- Rejwan: 24-02-2025 -->
            <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass">

            <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">{{btn_name}} <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-payrun-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>

        </b-modal>


        <b-modal id="decline-modal" title="Are you sure you want to decline this Advance ?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Decline <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="unapprove-modal" title="Are you sure you want to unapprove this Advance ?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Unapprove <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unapprove-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title" dialog-class="w-1200" title-class="w-800">
            <!-- <pf-loan-form :pageurl="this.$api_url" :flg="flg" :employee_id="0" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="getLoanData"></pf-loan-form>        -->
            <pf-loan-form-new :pageurl="this.$api_url" :flg="flg" :employee_id="emp_id" :employee_name="emp_name" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" :action_type="action_type" v-on:childToParent="getLoanData"></pf-loan-form-new>
        </b-modal>
        <b-modal id="bv-modal-pf-loan-transactions-wizard" size="lg" hide-footer v-bind:title="modal_title">
            <pf-loan-transactions-wizard :pageurl="this.$api_url" :employee_id="employee_id" :key="tx_popup_count" :loan_id="loan_id" ></pf-loan-transactions-wizard>
        </b-modal>

        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer>
        <div class="row table-head mx-2">
            <div class="col-sm-4 font-weight-bold py-2">
                Installment No.
            </div>
            <div class="col-sm-4 font-weight-bold py-2">
                Month
            </div>
            <div class="col-sm-4 font-weight-bold py-2">
                Amount
            </div>
        </div>

        <div class="row table-row hover-bg mx-2"  v-for="(row, index) in my_installments" :key="index">
            <div class="col-sm-4 py-2 align-items-center d-flex">
                <div :style="(row.status==3) ? styleA : styleB" ><template v-if="(row.installment_type==0)">Installment #{{index+1}}</template><template v-else>Service Charge Installment</template></div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{row.month}}</div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.amount)}}</div>
            </div>
        </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <!-- Start: Rejwan: 23-04-2026 Pay Manual Installment  -->
        <b-modal id="bv-modal-pf-manual-installments" title="Pay Manual Installments" hide-footer>
            <div class="row table-head">
                <div class="col-sm-1 py-2 d-flex align-items-center">
                    <b-form-checkbox v-model="all_manual_installments_selected" @change="toggleAllManualInstallments"
                    />
                </div>
                <div class="col-sm-4 font-weight-bold py-2">
                    Installment No.
                </div>                      
                <div class="col-sm-3 font-weight-bold py-2">
                    Month
                </div>
                <div class="col-sm-4 font-weight-bold py-2">
                    Amount
                </div>
            </div>

            <div class="row table-row hover-bg" v-for="(row, index) in manual_installments" :key="index">
                <div class="col-sm-1 py-2 d-flex align-items-center">
                    <b-form-checkbox v-model="row.is_checked" @change="syncManualInstallmentHeaderCheckbox" :disabled="row.is_disabled"/>
                </div>

                <div class="col-sm-4 py-2 align-items-center d-flex">
                    <div :style="row.status == 3 ? styleA : styleB">
                        <template v-if="row.installment_type == 0">
                            Installment #{{ index + 1 }}
                        </template>
                        <template v-else>
                            Sercvice Charge Installment
                        </template>
                    </div>
                </div>

                <div class="col-sm-3 py-2 align-items-center d-flex">
                    <div :style="row.status == 3 ? styleA : styleB">
                        {{ row.month }}
                    </div>
                </div>

                <div class="col-sm-4 py-2 align-items-center d-flex">
                    <div :style="row.status == 3 ? styleA : styleB">
                        {{ formatMoney(row.amount) }}
                    </div>
                </div>
            </div>

            <br />
            <div style="height: 10px; clear: both;">&nbsp;</div>

            <div class="full-width text-center">
                <b-button variant="secondary" size="sm" @click="$bvModal.hide('bv-modal-pf-manual-installments')">
                    Close
                </b-button>

                <b-button variant="primary" size="sm" :disabled="manualInstallmentSubmitLoading || selected_manual_installments.length === 0" @click="submitManualInstallments">
                    <span v-if="manualInstallmentSubmitLoading">Submitting...</span>
                    <span v-else>Submit</span>
                </b-button>
            </div>

            <div style="height: 5px; clear: both;">&nbsp;</div>
        </b-modal>
        <!-- End: Rejwan: 23-04-2026 Pay Manual Installment  -->

    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: ['pageurl', 'flg','is_trustee'],
        data(){

            return {

                loans:[],
                loan_id:'',
                employee_id:'',
                tx_popup_count:0,
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#009efb !important',
                my_installments:[],
                is_custom:'',
                is_status:'',
                bank_names: [
                    { value: null, text: "--Select--" },
                ],
                action_btn_text:'Download Schedule',
                modal_title:'',
                count:'',
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                default_tenure: [0,150,0],
                showoverlay_list : false,
                successmsg:'',
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                showoverlaymodal : false,
                show_loader:true,
                loan_entity_id:'',
                loan_update_status:'',
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Declined" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approved" },
                    { value: "3", text: "Pause/Stopped" },
                    { value: "4", text: "Returned" },
                ],
                 /**Child Component property data */
                is_action:1,
                checkbox:0,
                list_key:0,
                loans:[],
                default_column:['name','employee_code'],
                appended_column:[
                    { value: "company_loan_id", text: "Advance ID",type: "text"},
                    // { value: "loan_amount", text: "Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "loan_amount", text: "Amount", type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "deduction_start_month", text: "Deduction Start Month",type: "monthyear"},
                    // { value: "loan_status", text: "Application Status",type: "text"}, // Rejwan: 06-03-2025
                    { value: "loan_application_status", text: "Application Status",type: "text"}, // Rejwan: 27-07-2025
                    { value: "approval_pending", text: "Approval Pending", type: "text"}, // Rejwan: 28-04-2025 extra field
                    { value: "advance_criteria", text: "Advance Criteria", type: "text"} // Rejwan: 28-04-2025 extra field

                ],
                primary_key:'id',
                company_options:[],
                tmp_loans:[],
                approver_settings:[],
                /***Child Component property data */

                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',
                btn_name:'',
                loading:'',
                emp_id:'',
                emp_name:'',

                // Start: Rejwan: 23-04-2026 Pay Manual Installment 
                pay_manual_installment_count: 0,
                manual_installments: [],
                all_manual_installments_selected: false,
                manualInstallmentSubmitLoading: false,
                manual_installment_loan_id: null,
                // End: Rejwan: 23-04-2026 Pay Manual Installment 
                action_type: null,
            }
        },
        methods:{
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },

            showDeclineModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
            this.approvepass='';
            },

            showUnapproveModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 1;
            this.$bvModal.show('unapprove-modal');
            this.approvepass='';
            },
            showDeleteModal: function(pageflg)
            {
                this.approvepass= '';
                this.incorrectpass= '';
                this.payrun_delete_msg='Are you sure to Delete this loan';
                this.btn_name='Delete';
                this.loan_entity_id=pageflg;
                this.$bvModal.show('delete-payrun-modal');
                this.approvepass='';
            },
            // Start: Rejwan: 23-04-2026 Pay Manual Installment 
            showManualInstallments: function(loan_id)
            {
                this.manual_installment_loan_id = loan_id;

                if(!this.checkNet()) return false;
                    let currentObj = this; 
                    let formData = new FormData();
                    formData.append('loan_id', this.manual_installment_loan_id);        
                    this.manual_installments = [];
                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/loan/installments', formData)
                    .then(function (response) 
                    {
                        this.manual_installments = (response.data || []).map(row => ({
                            ...row,
                            is_checked: row.status == 3,
                            is_disabled: row.status == 3
                        }));
                        this.showoverlay = false;
                        this.$bvModal.show('bv-modal-pf-manual-installments');
                            
                    }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },

            toggleAllManualInstallments() {
                    this.manual_installments = this.manual_installments.map(row => {
                    if (row.is_disabled) {
                        return row;
                    }

                    return {
                        ...row,
                        is_checked: this.all_manual_installments_selected
                    };
                });
            },

            syncManualInstallmentHeaderCheckbox() {
                if (!this.manual_installments.length) {
                    this.all_manual_installments_selected = false;
                    return;
                }

                this.all_manual_installments_selected = this.manual_installments.every(
                    row => row.is_checked
                );
            },

            submitManualInstallments() {
                const selectedMonths = this.manual_installments
                    .filter(row => row.is_checked && !row.is_disabled)
                    .map(row => row.month);

                if (!selectedMonths.length) {
                    this.$bvToast.toast('Please select at least one installment.', {
                        title: 'Warning',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }

                this.manualInstallmentSubmitLoading = true;

                let formData = new FormData();
                formData.append('loan_id', this.manual_installment_loan_id);

                selectedMonths.forEach((month, index) => {
                    formData.append(`months[${index}]`, month);
                });

                axios.post(this.$api_url + '/pf/pay-manual-installment', formData)
                .then(response => {
                    this.$bvToast.toast('Manual installments submitted successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                    this.manualInstallmentSubmitLoading = false;
                    this.$bvModal.hide('bv-modal-pf-manual-installments');
                }).bind(this).catch(error => {
                    let message = 'Something went wrong.';
                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
            },
            // End: Rejwan: 23-04-2026 Pay Manual Installment
            showLoanTransactions: function(loan_id,employee_id)
            {
                this.loan_id = loan_id;
                this.employee_id = employee_id;
                this.tx_popup_count = this.tx_popup_count + 1;
                this.$bvModal.show('bv-modal-pf-loan-transactions-wizard');
            },
            showInstallment: function(loan)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('loan_id', loan);
                this.my_installments = [];
                this.showoverlay = true;
                axios.post(this.$api_url+'/pf/loan/installments', formData)
                .then(function (response)
                {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');

                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            pauseLoan: function(pageflg)
            {

                this.loading='load';
                var update_status = this.loan_update_status;
                let formData = new FormData();
                formData.append('loan_id', pageflg);
                formData.append('status', update_status);
                axios.post(this.$api_url+'/pf/loan/update-status', formData)
                    .then(function (response)
                    {
                        this.$bvModal.hide('pause-modal');
                        this.$bvModal.hide('approve-modal');
                        this.$bvModal.hide('decline-modal');
                        this.$bvModal.hide('unapprove-modal');

                        this.loan_entity_id='';
                        this.loan_update_status = '';
                        this.loading='';
                        this.getLoanData();
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
            deleteLoan: function(pageflg)
            {

                this.loading='load';
                let formData = new FormData();
                formData.append('loan_id', pageflg);
                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;
    			     this.loading='load';
                     formData.append('pass',pass);
                 }
                axios.post(this.$api_url+'/pf/loan/delete', formData)
                    .then(function (response)
                    {

                        console.log(response.data.success);
                        if(response.data.success==true){
                            this.$bvToast.toast(response.data.message, {
                                title: `Success !`,
                                variant: 'success',
                                solid: true
                            });
                        }else{
                            this.$bvToast.toast(response.data.message, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                        // Start: Rejwan: 18-06-2025 Password Validation
                        // this.$bvModal.hide('pause-modal');
                        // this.$bvModal.hide('approve-modal');
                        // this.$bvModal.hide('decline-modal');
                        // this.$bvModal.hide('unapprove-modal');
                        // this.$bvModal.hide('delete-modal');
                        // this.$bvModal.hide('delete-payrun-modal');

                        // this.loan_entity_id='';
                        // this.loan_update_status = '';
                        // this.loading='';
                        // this.getLoanData();

                        // Start: Rejwan: 18-06-2025 Password Validation
                        if(response.data.success==true) {
                            this.$bvModal.hide('pause-modal');
                            this.$bvModal.hide('approve-modal');
                            this.$bvModal.hide('decline-modal');
                            this.$bvModal.hide('unapprove-modal');
                            this.$bvModal.hide('delete-modal');
                            this.$bvModal.hide('delete-payrun-modal');

                            this.loan_entity_id='';
                            this.loan_update_status = '';
                            this.loading='';
                            this.getLoanData();
                        }
                        this.loading='';
                        // End: Rejwan: 18-06-2025 Password Validation
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        console.log(error);
                    });

            },
            listReturn:function(data)
            {
                // Start: Rejwan: 23-06-2026
                // if(data.action_id == 0)
                // {
                //     let currentObj = this;

                //     let formData = new FormData();

                //     formData.append('loan_id', data.id);
                //     formData.append('employee_id', data.employee_id);

                //     formData.append('d_type', 'excel');
                //     this.pfoverlay = true;
                //     this.report_data = [];
                //     this.installments = [];
                //     this.transactions = [];
                //     this.employee_info = [];

                //     this.downloadBlobResponse(
                //         axios.post(this.$api_url + '/pf/report/schedule', formData, { responseType: 'blob' }),
                //         'loader' // your loader key in this component
                //     );

                // }
                // End: Rejwan: 23-06-2026
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.id > 0)
                    {
                        var item  = this.loans.find(item => item.id === data.id);

                        if(data.action_id == 0)
                        {
                            //this.showEmployeeDetails(data.id);
                        }
                        else if(data.action_id == 1)
                        {
                             this.editLoanInfo(data.id,item.employee_id,item.name,0,0);
                        }
                        else if(data.action_id == 2)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,1,0);
                        }
                        else if(data.action_id == 3)
                        {
                            this.showDeclineModal(data.id);
                        }
                        else if(data.action_id == 4)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,0,3);
                        }
                        else if(data.action_id == 5)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,0,2, 'approve');
                        }
                        else if(data.action_id == 6)
                        {
                            this.showInstallment(data.id);
                        }
                        else if(data.action_id == 7)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,0,1, 'unapprove');
                        }
                        else if(data.action_id == 8)
                        {
                            this.showLoanTransactions(data.id);
                        }
                        else if(data.action_id == 9)
                        {
                            this.showDeleteModal(data.id);
                        }
                        // Start: Rejwan: 23-04-2026 Pay Manual Installment 
                        else if(data.action_id == 10)
                        {
                            this.showManualInstallments(data.id);
                        }
                        // End: Rejwan: 23-04-2026 Pay Manual Installment
                    }

                }
            },

            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getLoanData: function()
            {
                this.loan_title = 'PF Application Lists';
                if(!this.checkNet()) return false;
                let currentObj = this;
                currentObj.show_loader = true;

                axios.get(this.$api_url+'/pf/loan/applications' , {
                    params: {
                    }
                }).then(function(response){
                    this.tmp_loans = response.data.employee_data;
                    this.company_options = response.data.options;

                    if(this.tmp_loans.length > 0 )
                    {
                        this.tmp_loans.forEach(element => {
                                if(element.id > 0)
                                {
                                    let depth = parseInt(this.approver_settings.depth)
                                    if (isNaN(depth)) depth = 0;
                                    console.log(depth);
                                    // Start: Rejwan: 23-06-2026
                                    if(depth == 0) {
                                        element.approval_pending = "";
                                    }
                                    // End: Rejwan: 23-06-2026
                                    element.loan_amount = this.formatMoney(element.loan_amount);
                                    let dop = [];

                                    if(this.is_trustee == null || this.is_trustee == 0)
                                    {
                                        if(this.$acl['pf/get-distribution-list'] > 1)
                                        {
                                            // if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped'|| this.loan_stat_title[element.status] == 'Declined')
                                            if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped')
                                            {
                                                if(depth == 0)
                                                {
                                                    dop = dop.concat([{ label: 'Approve' , value: 5 }]);
                                                }
                                            }
                                            // if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined'))
                                            if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved') && element.is_disbursed == 0)
                                            {
                                                if(depth == 0)
                                                {
                                                    dop = dop.concat([{ label: 'Unapprove' , value: 7 }]);
                                                }
                                            }
                                            if(element.has_tx==0  &&  (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved') && element.is_disbursed == 0)
                                            {
                                                if(depth == 0)
                                                {
                                                    dop = dop.concat([{ label: 'Decline' , value: 3 }]);
                                                }

                                            }
                                            if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped') && element.is_disbursed == 0)
                                            {
                                                dop = dop.concat([{ label: 'Delete' , value: 9 }]);
                                            }
                                            if(this.loan_stat_title[element.status] == 'Approved')
                                            {
                                                dop = dop.concat([{ label: 'Pause / Stop' , value: 4 }]);
                                            }

                                            // if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped'|| this.loan_stat_title[element.status] == 'Declined')
                                            if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped')
                                            {
                                                dop = dop.concat([{ label: 'Edit' , value: 1 }]);
                                            }
                                            if(this.loan_stat_title[element.status] == 'Approved' && element.is_disbursed == 1)
                                            {
                                                dop = dop.concat([{ label: 'Manual Payment' , value: 2 }]);
                                                dop = dop.concat([{ label: 'Pay Manual Installment' , value: 10 }]); // Start: Rejwan: 23-04-2026 Pay Manual Installment 
                                            }
                                        }


                                        if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved'  ||  this.loan_stat_title[element.status] == 'Pause/Stopped')
                                        {
                                            dop = dop.concat([{ label: 'Installments' , value: 6 }]);
                                        }


                                        dop = dop.concat([{ label: 'Transactions' , value: 8 }]);

                                        element.actions = dop;
                                    }

                                }
                            });

                    }
                    this.$bvModal.hide('bv-modal-loan');
                    if(this.is_trustee != null && this.is_trustee == 1)
                    {
                        this.is_action = 0;
                    }

                    this.loans = this.tmp_loans;
                    this.list_key = this.list_key + 1;

                    currentObj.show_loader = false;
                }.bind(this)).catch(function (error){

                    currentObj.show_loader = false;
                    currentObj.serverError(error);

                    });

            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            editLoanInfo(loan_id,emp_id,emp_name,is_custom,is_status, action_type = null)
            {
                this.modal_title = "PF Advance Application";
                this.is_custom = is_custom;
                this.loan_id = loan_id;
                this.is_status = is_status;
                this.count = this.count + 1;
                this.emp_id = emp_id;
                this.emp_name = emp_name;
                this.action_type = action_type;
                this.$bvModal.show('bv-modal-loan');
            },
            getApprovalSettings()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/approver/company-settings', {
                    params: {
                        module: 7
                    }
                }).then(function(response){
                    this.approver_settings = response.data;
                    this.getLoanData();

                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            }
        },
        // Start: Rejwan: 23-04-2026 Pay Manual Installment 
        computed: {
            selected_manual_installments() {
                return this.manual_installments.filter(row => row.is_checked);
            }
        },
        // End: Rejwan: 23-04-2026 Pay Manual Installment 
        created: function(){

            this.getApprovalSettings();

            //this.updateTransactions();
        }
    }
</script>
